var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTagLine = function SvgIconTagLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFBFD",
    fillRule: "evenodd",
    d: "M6.147 1.263a1.75 1.75 0 0 1 1.309.424l.087.081 4.563 4.564a1.75 1.75 0 0 1 .079 2.39l-.08.084-3.299 3.3a1.75 1.75 0 0 1-2.39.079l-.085-.079-4.563-4.563a1.75 1.75 0 0 1-.513-1.277l.007-.12.275-3.024a1.75 1.75 0 0 1 1.48-1.572l.104-.012zm.18 1.16-.075.002-3.024.275a.58.58 0 0 0-.518.459l-.01.069-.276 3.024a.58.58 0 0 0 .12.41l.049.056 4.563 4.563a.583.583 0 0 0 .77.049l.055-.049 3.3-3.3a.584.584 0 0 0 .048-.77l-.048-.054-4.563-4.564a.58.58 0 0 0-.392-.17M4.267 4.269a1.75 1.75 0 1 1 2.475 2.475 1.75 1.75 0 0 1-2.475-2.475m1.65.825a.584.584 0 1 0-.825.825.584.584 0 0 0 .825-.825",
    clipRule: "evenodd"
  })));
};
export default SvgIconTagLine;